import type { ChatThreadMessage } from "../types/chat-thread-message";
import type { AdminChatMessage } from "../types";

/**
 * Convert a message from `chat.adminGetChatThreadMessages` (admin shape with
 * snake_case sender) into the user-facing `ChatThreadMessage` shape rendered by
 * `<ChatMessageList>`.
 */
export function adaptAdminMessageToUserMessage(
  message: AdminChatMessage,
): ChatThreadMessage {
  return {
    id: message.id,
    createdAt: new Date(message.createdAt).toISOString(),
    content: message.content,
    sender: {
      id: message.sender.id,
      firstName: message.sender.first_name,
      lastName: message.sender.last_name,
      organizationName: message.sender.organization_name,
    },
    isMe: message.is_me,
    isAiGenerated: message.isAiGenerated,
    isDeleted: message.isDeleted,
  };
}
